import createReducer from './createReducer';
import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from '../constants/actionTypes';

function createContentReducer(api, options = {}) {
  const { normalizeData = x => x, defaultData = [] } = options;

  const initialState = {
    data: defaultData,
    isLoading: false,
    pagination: {}
  };

  return createReducer(initialState, {
    [API_CALL_REQUEST]: (state, action) => {
      if (action.api === api) {
        return {
          isLoading: true
        };
      }
      return undefined;
    },

    [API_CALL_SUCCESS]: (state, action) => {
      if (action.api === api) {
        return {
          data: normalizeData(action.data.content),
          isLoading: false
        };
      }
      return undefined;
    },

    [API_CALL_FAILURE]: (state, action) => {
      if (action.api === api) {
        return {
          errors: action.errors,
          isLoading: false
        };
      }
      return undefined;
    }
  });
}

export default createContentReducer;
